<template>
  <div id="app">
    <router-view/>
    <remote-js gamename='塔人网络' id='pub-footer' src='http://res.zhaouc.com/footer/pub-footer.js'></remote-js>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
    'remote-js': {
      render(createElement) {
        return createElement('script', { attrs: { type: 'text/javascript', src: this.src }});
      },
      props: {
        src: { type: String, required: true },
      },
    },
  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue